import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { BadgeMobile } from "../ui/base/badge/Badge";
import { ScrollToTop } from "../ui/base/ScrollToTop";
import { Download } from "../ui/blocks/Download";
import { Footer } from "../ui/blocks/Footer";
import { Gallery } from "../ui/blocks/Gallery";
import { Info } from "../ui/blocks/Info";
import { Neighborhood } from "../ui/blocks/Neighborhood";
import ScrollMotion from "../ui/blocks/ScrollMotion/ScrollMotion";
import AutoPlayVideo from "../ui/blocks/video";
import { pixelTrackEvent } from "../utils/facebookPixel";

import { HeaderMenu } from "ui/blocks/HeaderVariant/components/HeaderMenu";
import { Header } from "ui/blocks/Header";
import { HeaderLogo } from "ui/blocks/HeaderVariant/components/HeaderLogo";
import { HeaderFilter } from "ui/blocks/HeaderVariant/components/HeaderFilter";
import styled from "styled-components";
import { HeaderNavigation } from "ui/blocks/HeaderVariant/components/HeaderNavigation";
import { HeaderSection } from "./user/classDetail/sections/HeaderSection";
import { themeColor } from "ui/theme";
const AboutPage = () => {
  const [headColor, setHeadColor] = useState("white");
  const [headSolid, setHeadSolid] = useState(false);
  const [bottomShow, setBottomShow] = useState(false);

  const {
    ref: inViewRef,
    inView,
    entry,
  } = useInView({
    /* Optional options */
    threshold: 0.5,
    triggerOnce: true,
  });

  useEffect(() => {
    if (window.innerWidth > 768) {
      window.scrollTo(0, 0);
    } else {
      setBottomShow(true);
    }
  }, [bottomShow]);

  useEffect(() => {
    pixelTrackEvent("Enter home page");
  }, []);

  return (
    <ScrollToTop>
      <HeaderContainer>
        <Row>
          <HeaderLogo />
          <HeaderFilter />
          <HeaderMenu />
        </Row>
      </HeaderContainer>

      <Navigation>
        <HeaderSection classType={"About Us"} />
      </Navigation>
      <ScrollMotion
        setHeadColor={setHeadColor}
        setHeadSolid={setHeadSolid}
        setBottomShow={setBottomShow}
        hideScrollHint={inView}
      />
      {bottomShow ? (
        <>
          <Info ref={inViewRef} />
          <BadgeMobile />
          <Download />
          <Neighborhood />
          <AutoPlayVideo />
          <Gallery />
          <Footer />
        </>
      ) : (
        ""
      )}
    </ScrollToTop>
  );
};

const HeaderContainer = styled.div`
  display: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  align-items: center;
  box-shadow: "none";
  background-color: "transparent";
  z-index: 99;
  padding: 0 40px;

  @media (max-width: 1200px) {
    box-shadow: none;
  }
  @media (max-width: 640px) {
    box-shadow: 0 4px 10px 2px #00000008;
    /* background-color: ${({ theme }) => theme.colors["white"]}; */
    padding: 0 20px;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Navigation = styled.div`
  margin-top: 100px;
  margin-bottom: -8rem;
  margin-left: 2rem; 
`;

export default AboutPage;
